import { Translation } from '@ngneat/transloco';
import { DataTableDescriptionInfoDtoProps, DataTableDtoProps, SystemInfoProps } from 'app/data-api';

export default function getDisplayedTableColumns(translocoContent: Translation) {
    return [
        {
            columnName: translocoContent['tableFields.system'],
            columnKey: DataTableDtoProps.system,
            contentType: 'string',
            enableSorting: true,
        },
        {
            columnName: translocoContent['tableFields.system'],
            columnKey: DataTableDtoProps.systemInfo + '.' + SystemInfoProps.description,
            contentType: 'string',
            enableSorting: true,
        },
        {
            columnName: translocoContent['tableFields.system'],
            columnKey: DataTableDtoProps.systemInfo + '.' + SystemInfoProps.systemName,
            contentType: 'string',
            enableSorting: true,
        },
        {
            columnName: translocoContent['tableFields.category'],
            columnKey: DataTableDtoProps.category,
            contentType: 'string',
            enableSorting: true,
        },
        {
            columnName: translocoContent['tableFields.tableName'],
            columnKey: DataTableDtoProps.tableName,
            contentType: 'string',
            enableSorting: true,
        },
        {
            columnName: translocoContent['tableFields.businessObject'],
            columnKey: DataTableDtoProps.businessObject,
            contentType: 'string',
            enableSorting: true,
        },
        {
            columnName: translocoContent['tableFields.version'],
            columnKey: DataTableDtoProps.version,
            contentType: 'string',
            enableSorting: true,
        },
        {
            columnName: translocoContent['tableFields.wbs'],
            columnKey: DataTableDtoProps.wbs,
            contentType: 'string',
            enableSorting: true,
        },
        {
            columnName: translocoContent['tableFields.shortDescription'],
            columnKey:
                DataTableDtoProps.descriptionInfo +
                '.' +
                DataTableDescriptionInfoDtoProps.shortDescription,
            contentType: 'string',
            enableSorting: true,
        },
        {
            columnName: translocoContent['tableFields.heading'],
            columnKey:
                DataTableDtoProps.descriptionInfo + '.' + DataTableDescriptionInfoDtoProps.heading,
            contentType: 'boolean',
            enableSorting: true,
        },
        {
            columnName: translocoContent['tableFields.headingLength'],
            columnKey:
                DataTableDtoProps.descriptionInfo +
                '.' +
                DataTableDescriptionInfoDtoProps.headingLength,
            contentType: 'string',
            enableSorting: true,
        },
        {
            columnName: translocoContent['tableFields.shortFieldLabel'],
            columnKey:
                DataTableDtoProps.descriptionInfo +
                '.' +
                DataTableDescriptionInfoDtoProps.shortTableLabel,
            contentType: 'string',
            enableSorting: true,
        },
        {
            columnName: translocoContent['tableFields.shortFieldLabelLength'],
            columnKey:
                DataTableDtoProps.descriptionInfo +
                '.' +
                DataTableDescriptionInfoDtoProps.shortTableLabelLength,
            contentType: 'string',
            enableSorting: true,
        },
        {
            columnName: translocoContent['tableFields.mediumFieldLabel'],
            columnKey:
                DataTableDtoProps.descriptionInfo +
                '.' +
                DataTableDescriptionInfoDtoProps.mediumTableLabel,
            contentType: 'string',
            enableSorting: true,
        },
        {
            columnName: translocoContent['tableFields.mediumFieldLabelLength'],
            columnKey:
                DataTableDtoProps.descriptionInfo +
                '.' +
                DataTableDescriptionInfoDtoProps.mediumTableLabelLength,
            contentType: 'string',
            enableSorting: true,
        },
        {
            columnName: translocoContent['tableFields.longFieldLabel'],
            columnKey:
                DataTableDtoProps.descriptionInfo +
                '.' +
                DataTableDescriptionInfoDtoProps.longTableLabel,
            contentType: 'string',
            enableSorting: true,
        },
        {
            columnName: translocoContent['tableFields.longFieldLabelLength'],
            columnKey:
                DataTableDtoProps.descriptionInfo +
                '.' +
                DataTableDescriptionInfoDtoProps.longTableLabelLength,
            contentType: 'string',
            enableSorting: true,
        },
        {
            columnName: translocoContent['tableFields.description'],
            columnKey:
                DataTableDtoProps.descriptionInfo +
                '.' +
                DataTableDescriptionInfoDtoProps.description,
            contentType: 'string',
            enableSorting: true,
        },
    ];
}
